<template>
  <div>
    <b-row class="cooperation justify-content-center">
      <b-col class="col-11 col-md-6 text-center flex align-self-center">
        <p class="team-up-title" tabindex="0">
          {{ $t("bulbsTitle") }}
        </p>
      </b-col>
    </b-row>
    <b-row class="text-center my-3">
      <b-col class="justify-contant-center">
        <p class="team-up-description" tabindex="0">
          {{ $t("teamUpDescription") }}
        </p>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <b-col>
        <div class="text-center">
          <b-button
            href="https://center1.by/kontakty.html"
            target="_blank"
            pill
          >
            <!-- height="80"
            width="350" -->
            <p class="px-2 my-2" style="font-size: 1.5rem;">
              {{ $t("teamUpButton") }}
            </p>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <!-- </v-card-actions> -->
    <b-row class="text-center mb-3">
      <b-col tabindex="0">
        {{ $t("bookletTitle") }}
        <a
          href="./assets/files/BuzzPointRu.pdf"
          download
          style="text-decoration: none; vertical-align: middle; font-weight: 600;"
        >
          &nbsp;&nbsp;RU
        </a>
        <a
          href="./assets/files/BuzzPointEn.pdf"
          download
          style="text-decoration: none; vertical-align: middle; font-weight: 600;"
        >
          &nbsp;&nbsp;EN
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.cooperation::before {
  content: " ";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.3;
  background: url("./../assets/bulbs.jpg");
  background-repeat: no-repeat;
  background-position: 50% 0;
  -ms-background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  background-size: cover;

  background-attachment: fixed;
}

.cooperation {
  height: 50vh;
  color: white;
  position: relative;
  background: #000;
  overflow: hidden;
}

.team-up-title {
  font-size: 1.5rem;
}

.team-up-description {
  font-size: 1rem;
  margin: 0 5%;
}

.team-up-button {
  width: 80%;
  height: 80px;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

@media screen and (min-width: 668px) {
  /* .cooperation::before {
    content: " ";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: 0.3;
    background: url("./../assets/bulbs.jpg");
    background-repeat: no-repeat;
    background-position: 50% 0;
    -ms-background-size: cover;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    background-size: cover;

    background-attachment: fixed;
  }

  .cooperation {
    height: 50vh;
    color: white;
    position: relative;
    background: #000;
    overflow: hidden;
  } */

  .team-up-title {
    font-size: 2rem;
  }

  .team-up-description {
    font-size: 1.4rem;
    margin: 0 20%;
  }

  .team-up-button {
    width: 350px;
    height: 100px;
  }
}
/* .cooperation {
  background: url("./../assets/bulbs.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  height: 50vh;
  color: white;
} */
</style>
